module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, _vm._l((_vm.campaignTypes), function(type) {
    return _c('el-tab-pane', {
      key: type.type
    }, [_c('strong', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(type.label))]), _vm._v(" "), _c('el-card', [_c('campaign-filter-table', {
      attrs: {
        "campaigns": _vm.getCampaignsByType(type.type)
      },
      on: {
        "change": _vm.handleCampaignSelection
      }
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6",
    attrs: {
      "id": "selected-campaigns"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('strong', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Selected Campaigns")]), _vm._v(" "), _c('el-card', [_c('campaign-filter-table', {
    attrs: {
      "empty-text": 'No selected campaigns or surveys',
      "selectorTable": false,
      "campaigns": _vm.selectedCampaigns
    }
  })], 1)], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d5aee84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/filters/CampaignsFilter.vue
// module id = 3139
// module chunks = 3